import React from 'react';

import { useRouteMatch } from 'react-router';
import { Redirect } from 'react-router-dom';

import { localizeUrl } from 'helpers/locales';

interface IProps {
  to: string | { pathname: string };
  [key: string]: any;
}

const NestedRedirect = ({ to, ...props }: IProps) => {
  const { url } = useRouteMatch();

  let customTo;

  let localizedUrl;

  if (typeof to == 'object') {
    localizedUrl = localizeUrl(url, to.pathname);
    customTo = { ...to, to: localizedUrl };
  } else {
    localizedUrl = localizeUrl(url, to);
    customTo = { to: localizedUrl };
  }

  return <Redirect {...customTo} {...props} />;
};

export default NestedRedirect;
